import React from "react";
import styled from "styled-components";
import Tooltip from "@ui-kit/tooltip";

const Item = styled.div`
  display: inline-block;
`;

const RadarlyCardStatus = ({ tooltip, children }) => {
  return (
    <Item>
      <Tooltip tooltip={tooltip} placement="top">
        <div>{children}</div>
      </Tooltip>
    </Item>
  );
};

export default RadarlyCardStatus;
